import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import { VehicleModel } from '../../models/resources/vehicle.model';

@Injectable({
  providedIn: 'root',
})
export class LocationVehicleService extends AResourceService<VehicleModel> {
  constructor() {
    super('/vehicles', true, [
      'location'
    ]);
  }

  setLocationId(id: number) {
    this.setResourceUrl(`/locations/${id}/vehicles`);
  }
}
